import crypto from 'crypto';
/**
 * Calculate MD5 hash for the given data.
 * @param {object} data - The data to be hashed.
 * @returns {string} - The MD5 hash.
 */
export const calculateMD5 = (data) => {
    const base64Data = Buffer.from(JSON.stringify(data), 'utf-8').toString('base64');
    const hash = crypto.createHash('md5');
    hash.update(base64Data);
    return hash.digest('hex');
  };
  
  export const generateEpochTimestamp = () => {
    var currentTimestamp = Math.floor(Date.now() / 1000);
    return currentTimestamp;
  };
  
  export  const generateSignature = (timestamp, token) => {
    var sampleString = String(timestamp);
    var sampleStringBytes = new TextEncoder().encode(sampleString);
    var base64Bytes = btoa(String.fromCharCode.apply(null, sampleStringBytes));
    var tokenNew = token + "-" + base64Bytes;
  
    var sampleTokenString = String(tokenNew);
    var sampleTokenStringBytes = new TextEncoder().encode(sampleTokenString);
    var base64TokenBytes = btoa(String.fromCharCode.apply(null, sampleTokenStringBytes));
    return base64TokenBytes;
  };
  
  export const generateHeaders = () =>{
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    
    
    // const checksum = calculateMD5(payload);
    // console.log("MD5 Checksum:", checksum);
  
    const authtimestamp = generateEpochTimestamp();
    // console.log("Epoch Timestamp:", authtimestamp);
  
    const authsignature = generateSignature(authtimestamp,authToken);
    // console.log("Signature:", authsignature);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    myHeaders.append("Content-Type",  'application/json');
    // myHeaders.append("Checksum", checksum);
    myHeaders.append("Timestamp",authtimestamp);
    myHeaders.append("Signature",authsignature);
    // console.log("HEADER",myHeaders);
    return myHeaders;
  };
  
  export const generateHeaderswithBasicAuthToken = (ntype, token) =>{
    // let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = token;
    
    
    // const checksum = calculateMD5(payload);
    // console.log("MD5 Checksum:", checksum);
  
    const authtimestamp = generateEpochTimestamp();
    // console.log("Epoch Timestamp:", authtimestamp);
  
    const authsignature = generateSignature(authtimestamp,authToken);
    // console.log("Signature:", authsignature);
    var myHeaders = new Headers();
    if (ntype == 'Basic'){
        myHeaders.append("Authorization", "Basic " + authToken);
        }
    if (ntype == 'Token'){
        myHeaders.append("Authorization", "Token " + authToken);
        }
    myHeaders.append("Content-Type",  'application/json');
    // myHeaders.append("Checksum", checksum);
    myHeaders.append("Timestamp",authtimestamp);
    myHeaders.append("Signature",authsignature);
    // console.log("HEADER",myHeaders);
    return myHeaders;
  };        


// WEBPACK FOOTER //
// ./src/utils/helper.js